import { render, staticRenderFns } from "./dictManage.vue?vue&type=template&id=454a1931&scoped=true&"
import script from "./dictManage.vue?vue&type=script&lang=js&"
export * from "./dictManage.vue?vue&type=script&lang=js&"
import style0 from "./dictManage.vue?vue&type=style&index=0&id=454a1931&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "454a1931",
  null
  
)

export default component.exports